import { Platform } from "../../../types/platform";

/**
 * Which native dependency manager a release's platform actually uses.
 *
 * The two integration cards on the adapter/SDK pages are NOT platform-neutral: `IntegrationTable`
 * renders pod-shaped rows and `SpmIntegrationTable` renders Swift Package rows. Labelling both
 * "CocoaPods"/"SPM" on an Android release is simply wrong — Android integrates through
 * Maven/Gradle, and Swift Package Manager does not exist there at all.
 */
export const nativeIntegrationLabel = (platform?: Platform | string): string =>
  platform === Platform.IOS ? "CocoaPods" : "Maven / Gradle";

/**
 * SPM is iOS-only. The crawler never anchors an SPM row on an Android target — see
 * `AbstractSpmCrawler`, and the `platform` column on `/wizard/spm`, which exists precisely so a
 * non-`ios` row shows up as the anomaly it would be.
 *
 * The gate is on platform rather than on "did the request come back empty": an empty Swift Package
 * card on an Android page reads as missing data, when the honest answer is not-applicable.
 */
export const supportsSpm = (platform?: Platform | string): boolean =>
  platform === Platform.IOS;
